import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerRemoveEmployee'

export default (managerId, employeeId) => (asyncAction(
  name,
  ManagersService.removeEmployee,
  { managerId, employeeId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerRemoveEmployee.js